<template>
  <div id="app" v-cloak>
    <headers></headers>
    <router-view/>
    <footers></footers>
  </div>
</template>

<script>
import headers from '@/components/common/header'
import footers from '@/components/common/footer'
export default {
  name: 'App',
  data () {
    return {
      whichType: ''
    }
  },
  components: {
    headers,
    footers
  },
  methods: {
  },
  mounted () {
    (function (doc, win) {
      const docEl = doc.documentElement
      const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
      const recalc = function () {
        const clientWidth = docEl.clientWidth > 767 ? 767 : docEl.clientWidth
        if (!clientWidth) return
        docEl.style.fontSize = 24 * (clientWidth / 640) + 'px'
      }
      if (!doc.addEventListener) return
      win.addEventListener(resizeEvt, recalc, false)
      doc.addEventListener('DOMContentLoaded', recalc, false)
    })(document, window)
  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue